export default __webpack_public_path__ + "static/media/menu-burger.71e29749.svg";